// src/components/SchemaEditor.tsx
import React from 'react';
import 'jsoneditor-react/es/editor.min.css';
import 'jsoneditor/dist/jsoneditor.min.css';
import { TailSpin } from 'react-loader-spinner';

// Dynamically require the JSON editor component.
const JSONEditor: React.ComponentType<any> = (() => {
  const mod = require('jsoneditor-react');
  // Try different export names.
  return mod.default || mod.JSONEditor || mod.JsonEditor;
})();

interface SchemaEditorProps {
  schema: any;
}

const SchemaEditor: React.FC<SchemaEditorProps> = ({ schema }) => {
  // When no schema is selected, display a message.
  if (schema === undefined) {
    return (
      <div className="schema-editor" style={{ padding: '20px' }}>
        <p>Select a schema from the tree to edit.</p>
      </div>
    );
  }
  // When a schema is selected but still loading, show a spinner.
  if (schema === null) {
    return (
      <div
        className="schema-editor"
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className="spinner-container" style={{ textAlign: 'center' }}>
          <TailSpin color="#007bff" height={50} width={50} />
          <p>Loading schema...</p>
        </div>
      </div>
    );
  }
  // When schema is fetched, render the editor.
  return (
    <div className="schema-editor" style={{ height: '100%' }}>
      <JSONEditor
        key={JSON.stringify(schema)} // Force remount when schema changes.
        value={schema}
        onChange={(updatedSchema: any) => {
          console.log("Editor updated schema:", updatedSchema);
          // You can handle updated schema here.
        }}
        mode="tree"
      />
    </div>
  );
};

export default SchemaEditor;
